import { getConsumptionModeList } from 'state/consumptionModeList';
import { getOrders, getOrdersTotalPriceBreakdown } from 'state/orders';
import { useAppSelector } from 'state/store';
import { useLuncheonVoucherEligibilityRules } from 'hooks/useLuncheonVoucherEligibilityRules/useLuncheonVoucherEligibilityRules';
import { PaymentMethodCode } from 'services/consumptionMode/consumptionMode.type';
import { useFeatureFlag } from 'hooks/useFeatureFlag/useFeatureFlag';

export const useEdenredPayment = () => {
    const consumptionModeList = useAppSelector(getConsumptionModeList);
    const currentOrders = useAppSelector(getOrders);

    const { totalInclTaxWithDiscount } = useAppSelector(getOrdersTotalPriceBreakdown);
    const MAX_DAILY_AMOUNT = 2500;

    const { cartContainsOnlyEligibleProducts } = useLuncheonVoucherEligibilityRules();

    const { useEdenredPayments } = useFeatureFlag();

    if (!currentOrders || !consumptionModeList || !useEdenredPayments) {
        return {
            hasEdenredPaymentMethod: false,
        };
    }

    const hasEdenredPaymentMethod = Object.values(currentOrders).reduce((result, currentOrder) => {
        const currentConsumptionMode = currentOrder.consumptionMode;
        const orderConsumptionMode = consumptionModeList[currentOrder.restaurantId];

        // TODO: To fix multi-order-paiements hydrate consumptionModeList for allRestaurants at once
        if (!orderConsumptionMode) {
            return false;
        }
        const selectedConsumptionMode = orderConsumptionMode.find(
            ({ type }) => type === currentConsumptionMode,
        );

        const isEdenredActive = !!selectedConsumptionMode?.paymentMethods.find(
            ({ code, active }) => active && code === PaymentMethodCode.Edenred,
        );

        return result && isEdenredActive;
    }, true);

    return {
        hasEdenredPaymentMethod,
        cartContainsOnlyEligibleProducts,
        amountIsBelowMaximumDaily: totalInclTaxWithDiscount <= MAX_DAILY_AMOUNT,
    };
};
